import React, { useState } from 'react';
import { Modal, Box, TextField, Typography, Button } from '@mui/material';
import COLORS from '../../../../resources/style/Themes';

const AddNoteModal = ({ show, onHide, onCreate, organization }) => {
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');

  const handleSubmit = () => {
    const newMessage = {
      note_name: title,
      note: content,
      org_code: organization.org_code,
      organization_azure_id: organization.id,
    };

    onCreate(newMessage);
    resetValues();
    onHide();
  };

  const resetValues = () => {
    setContent('');
    setTitle('');
  };

  return (
    <Modal
      open={show}
      onClose={() => {
        onHide();
        resetValues();
      }}
      aria-labelledby="add-note-modal-title"
      aria-describedby="add-note-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          outline: 'none',
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            backgroundColor: COLORS.SAFEGUARD_BLUE,
            color: COLORS.WHITE,
            padding: 2,
            textAlign: 'center',
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2,
          }}
        >
          <Typography id="add-note-modal-title" variant="h6">
            Add New Note
          </Typography>
        </Box>
        {/* Modal Content */}
        <Box component="form" sx={{ p: 4 }}>
          <TextField
            fullWidth
            label="Note Title"
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Note Content"
            variant="outlined"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            sx={{ mb: 2 }}
          />
        </Box>
        {/* Footer Section */}
        <Box sx={{ textAlign: 'right', p: 2 }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
          >
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddNoteModal;
